
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteBrand from "./ModalDeleteBrand";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import Action from "../../Action";
import FlujoModal from "../../modals-monitoreo/FlujoModal";
import React from 'react';
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const customStylesFlujo = {
  content: {
    top: '50%',
    left: '50%',
    background: 'transparent',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'50%',
    height:'90%',
    padding:'20px',
    border:'unset'
  },
};
class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  }
  
const EventsList = (props) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  const [flujoOpen, setFlujoOpen] = useState(false);
  const [eventSelected,setEventSelected]=useState("")
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    props.setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const [auxProps,setAuxProps] = useState({});
  const openFlujo=(element)=>{
    setEventSelected(""+element.eventid)
    setAuxProps({
      ...props,
      data: element,
    })
    setFlujoOpen(true)
  }
  function closeFlujo() {
    setFlujoOpen(false)
  }
  const cisSelectRow = (elemento) => {
    props.setCisSelected(elemento);
  };
  //  console.log(props.dataUsers.loading,props.dataList.length)
  return (
    <>
      <div className="cont-row-user-list">
        {props.loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          props.dataList
            .slice(props.startLimit, parseInt(props.pageActual) * parseInt(props.limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+props.mode}
                key={indice}
                style={{height:'45px'}}
              >
                 
                <div className="field-body-table-mantenimiento field-medium">
                  {elemento.eventid}
                </div>
                <div className="field-body-table-mantenimiento field-larger"   style={{width:'22%'}}>
                  {elemento.message}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  style={{width:'15%'}} >
                  {elemento.alias}
                </div>
                <div className="field-body-table-mantenimiento field-larger"  style={{width:'30%'}}>
                  {elemento.hostname}
                </div>
                <div className="field-body-table-mantenimiento field-medium">
                  {elemento.ip}
                </div>
                <div className="field-body-table-mantenimiento field-medium" >
                  {elemento.created_at.replace("T"," ")}
                </div>
                <div className="field-body-table-mantenimiento field-medium" >
                  {(elemento.recovered_at==null)?elemento.recovered_at:elemento.recovered_at.replace("T"," ")}
                </div>
                <div className="field-body-table-mantenimiento field-medium" >
                {(elemento.closed_at==null)?elemento.closed_at:elemento.closed_at.replace("T"," ")}
                  
                </div>
                <div className="field-body-table-mantenimiento field-medium" >
                  <div className='menuActionCell contEventsActions' style={{border: 'unset'}}>

                    {/* <Action origen='Azul' disabled={false} titulo='Flujo' action={()=>openFlujo(elemento.eventId)}/> */}
                    <div className='contBtnCorrelacion' style={{position:'relative',display:'flex',height:'100%',justifyContent:'center',alignItems:'center'}}>
                                <button class=" actAzul " style={{minHeight:'unset',height:'3vh',width:'15vh',fontSize:'var(--font-size-xSmall)'}} onClick={()=>{openFlujo(elemento)}}>Flujo</button>
                                </div>
                  </div>
                                    
                </div>
                {/* <div className="field-body-table-mantenimiento field-larger" >
                  {elemento.closed_at}
                </div> */}
              
                
                
              </div>
            ))
        )}
        { props.dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[props.languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteBrand  handleShowPopup={props.handleShowPopup} props={props} languaje={props.languaje} mode={props.mode} buscar_cis={props.buscar_cis} server={props.server} setData={props.setData} setLoading={props.setLoading} setError={props.setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteBrand>
    </Modal>
    <Modal
          isOpen={flujoOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeFlujo}
          style={customStylesFlujo}
          contentLabel="Example Modal"
          // shouldCloseOnOverlayClick={true}
            >
             
              <FlujoModal eventId={eventSelected} props={auxProps} ></FlujoModal>
                              
            </Modal>
    </>
  );
};

export default EventsList;
